module.exports = __webpack_public_path__ + "img/39600.9842ec7b.jpg";